var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.diff !== 0)?_c('span',{class:_vm.colorClass},[_c('v-icon',{class:_vm.colorClass},[_vm._v(_vm._s(_vm.icon))]),_vm._v("("+_vm._s(Number(_vm.percentageDiff.toFixed(2)))+"%)\n")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }